const Trademark = {
    namespaced: true,
    getters: {},
    state: {
        TrademarkImage: '',
    },
    mutations: {
        SETIMAGE(state, res){
            state.TrademarkImage = res
        }
    },
    actions: {},
}
export default Trademark